import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/rubik-hebrew-normal-e59af50a.woff2%22,%22weight%22:%22300%20900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22ui%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0307-0308,%20U+0590-05FF,%20U+200C-2010,%20U+20AA,%20U+25CC,%20U+FB1D-FB4F%22}]}],%22variableName%22:%22uiHebrew%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'uiHebrew'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
